import { defineMessages } from 'react-intl';

export const filterMessages = defineMessages({
  addressLine1: {
    description: 'Workflow filter field label - Address Line 1',
    defaultMessage: 'Address Line 1',
    id: '2TMS8W',
  },
  addressLine2: {
    description: 'Workflow filter field label - Address Line 2',
    defaultMessage: 'Address Line 2',
    id: 'bzv+Lv',
  },
  addressVerification: {
    description: 'Workflow filter field label - Address Verified',
    defaultMessage: 'Address Verified',
    id: 'Tcj2PL',
  },
  amountPaid: {
    description: 'Workflow filter field label - Amount Paid',
    defaultMessage: 'Amount Paid',
    id: 'noaSGR',
  },
  assignedUser: {
    description: 'Workflow filter field label - Assigned User',
    defaultMessage: 'Assigned User',
    id: 'kFeVZM',
  },
  billToParty: {
    description: 'Workflow filter field label - Shipping Account (bill to party)',
    defaultMessage: 'Shipping Account',
    id: 'jqOdCi',
  },
  buyerId: {
    description: 'Workflow filter field label - Buyer ID',
    defaultMessage: 'Buyer ID',
    id: 'U9AjAZ',
  },
  buyerName: {
    description: 'Workflow filter field label - Customer (buyer name)',
    defaultMessage: 'Customer',
    id: 'dHEPvY',
  },
  carrier: {
    description: 'Workflow filter field label - Carrier',
    defaultMessage: 'Carrier',
    id: '33v6Rn',
  },
  city: {
    description: 'Workflow filter field label - City',
    defaultMessage: 'City',
    id: 'vy/47v',
  },
  country: {
    description: 'Workflow filter field label - Country',
    defaultMessage: 'Country',
    id: 'TWR1+n',
  },
  customField1: {
    description: 'Workflow filter field label - Custom Field 1',
    defaultMessage: 'Custom Field 1',
    id: 'Vuxm08',
  },
  customField2: {
    description: 'Workflow filter field label - Custom Field 2',
    defaultMessage: 'Custom Field 2',
    id: 'tIsCUi',
  },
  customField3: {
    description: 'Workflow filter field label - Custom Field 3',
    defaultMessage: 'Custom Field 3',
    id: 'g+vT/o',
  },
  datePaid: {
    description: 'Workflow filter field label - Date Paid',
    defaultMessage: 'Date Paid',
    id: 'p3DLoq',
  },
  deliverByDate: {
    description: 'Workflow filter field label - Deliver By Date',
    defaultMessage: 'Deliver By Date',
    id: '1r/rTo',
  },
  fulfillmentProvider: {
    description: 'Workflow filter field label - Fulfillment Provider',
    defaultMessage: 'Fulfillment Provider',
    id: '0UDVSe',
  },
  internalNotes: {
    description: 'Workflow filter field label - Internal Notes',
    defaultMessage: 'Internal Notes',
    id: '/85jED',
  },
  isGift: {
    description: 'Workflow filter field label - Gift Order',
    defaultMessage: 'Gift Order',
    id: 'wXurPn',
  },
  isInternational: {
    description: 'Workflow filter field label - International Order',
    defaultMessage: 'International Order',
    id: 's6btbK',
  },
  itemName: {
    description: 'Workflow filter field label - Item Name',
    defaultMessage: 'Item Name',
    id: 'RD7qTm',
  },
  itemSku: {
    description: 'Workflow filter field label - Item Sku',
    defaultMessage: 'Item Sku',
    id: '4AdNY4',
  },
  lineItemCount: {
    description: 'Workflow filter field label - # of Line Items',
    defaultMessage: '# of Line Items',
    id: 'wLl1WZ',
  },
  marketplace: {
    description: 'Workflow filter field label - Marketplace',
    defaultMessage: 'Marketplace',
    id: 'fpfjKD',
  },
  notesFromBuyer: {
    description: 'Workflow filter field label - Notes from the Buyer',
    defaultMessage: 'Notes from the Buyer',
    id: 'l63iYq',
  },
  notesToBuyer: {
    description: 'Workflow filter field label - Notes to the Buyer',
    defaultMessage: 'Notes to the Buyer',
    id: 'zkjGLh',
  },
  orderDate: {
    description: 'Workflow filter field label - Order Date',
    defaultMessage: 'Order Date',
    id: 'Gcbqm6',
  },
  orderImportTime: {
    description: 'Workflow filter field label - Order Import Time',
    defaultMessage: 'Order Import Time',
    id: 'uzPRyy',
  },
  orderNumber: {
    description: 'Workflow filter field label - Order #',
    defaultMessage: 'Order #',
    id: 'S6AZrC',
  },
  orderSource: {
    description: 'Workflow filter field label - Order Source',
    defaultMessage: 'Order Source',
    id: '2NcgN9',
  },
  orderSubtotal: {
    description: 'Workflow filter field label - Order Subtotal',
    defaultMessage: 'Order Subtotal',
    id: 'rbPuZK',
  },
  orderTotal: {
    description: 'Workflow filter field label - Order Total',
    defaultMessage: 'Order Total',
    id: 'U26hr6',
  },
  orderWeight: {
    description: 'Workflow filter field label - Order Weight',
    defaultMessage: 'Order Weight',
    id: 'DsS2z1',
  },
  packageType: {
    description: 'Workflow filter field label - Package',
    defaultMessage: 'Package',
    id: 'obhPD0',
  },
  paymentMethod: {
    description: 'Workflow filter field label - Payment Method',
    defaultMessage: 'Payment Method',
    id: '2HpnqG',
  },
  postalCode: {
    description: 'Workflow filter field label - Postal Code',
    defaultMessage: 'Postal Code',
    id: 'cHQEr0',
  },
  recipientCompany: {
    description: 'Workflow filter field label - Recipient Company',
    defaultMessage: 'Recipient Company',
    id: 'XD6m4e',
  },
  recipientName: {
    description: 'Workflow filter field label - Recipient Name',
    defaultMessage: 'Recipient Name',
    id: 'itfen8',
  },
  requestedServiceMapped: {
    description: 'Workflow filter field label - Requested Service (Mapped)',
    defaultMessage: 'Requested Service (Mapped)',
    id: '27Bn8T',
  },
  requestedServiceUnmapped: {
    description: 'Workflow filter field label - Requested Service (Marketplace Value)',
    defaultMessage: 'Requested Service (Marketplace Value)',
    id: 'xCNiKO',
  },
  residentialIndicator: {
    description: 'Workflow filter field label - Residential / Commercial',
    defaultMessage: 'Residential / Commercial',
    id: 'mezNkZ',
  },
  sellerBrand: {
    description: 'Workflow filter field label - Brand',
    defaultMessage: 'Brand',
    id: 'wdnfpL',
  },
  shipByDate: {
    description: 'Workflow filter field label - Ship By Date',
    defaultMessage: 'Ship By Date',
    id: 'eXd+52',
  },
  shipFrom: {
    description: 'Workflow filter field label - Ship From Location',
    defaultMessage: 'Ship From Location',
    id: 'A0cQMF',
  },
  shippingAccount: {
    description: 'Workflow filter field label - Shipping Account',
    defaultMessage: 'Shipping Account',
    id: 'zvEIj2',
  },
  shippingPaid: {
    description: 'Workflow filter field label - Shipping Paid',
    defaultMessage: 'Shipping Paid',
    id: 'JMf/vI',
  },
  shopifyShipFrom: {
    description: 'Workflow filter field label - Shopify Ship From Location',
    defaultMessage: 'Shopify Ship From Location',
    id: 'BrOUA2',
  },
  stateProvince: {
    description: 'Workflow filter field label - State',
    defaultMessage: 'State',
    id: 'lv4ruT',
  },
  store: {
    description: 'Workflow filter field label - Store',
    defaultMessage: 'Store',
    id: 'fwcnwQ',
  },
  tags: {
    description: 'Workflow filter field label - Order Tags',
    defaultMessage: 'Order Tags',
    id: 'sUiW33',
  },
  taxPaid: {
    description: 'Workflow filter field label - Tax Paid',
    defaultMessage: 'Tax Paid',
    id: 'X3KTKA',
  },
  totalQuantity: {
    description: 'Workflow filter field label - Total Quantity',
    defaultMessage: 'Total Quantity',
    id: 'k73CDg',
  },
  uspsZone: {
    description: 'Workflow filter field label - USPS Zone',
    defaultMessage: 'USPS Zone',
    id: 'wzJG/v',
  },
  warehouseLocation: {
    description: 'Workflow filter field label - Warehouse Location',
    defaultMessage: 'Warehouse Location',
    id: 'TG5+v+',
  },
});

export const triggerMessages = defineMessages({
  orderImported: {
    description: 'Workflow trigger label - Order imported',
    defaultMessage: 'Order imported',
    id: 'XcqiTl',
  },
  orderUpdated: {
    description: 'Workflow trigger label - Order updated',
    defaultMessage: 'Order updated',
    id: 'jqTqch',
  },
  orderStatusChanged: {
    description: 'Workflow trigger label - Order status changed',
    defaultMessage: 'Order status changed',
    id: 'Vq+RBB',
  },
  orderTagAdded: {
    description: 'Workflow trigger label - Tag added',
    defaultMessage: 'Tag added',
    id: 'XlEOpU',
  },
  orderTagRemoved: {
    description: 'Workflow trigger label - Tag removed',
    defaultMessage: 'Tag removed',
    id: 'jGGdHi',
  },
});

export const actionMessages = defineMessages({
  addInternalNote: {
    description: 'Workflow action type label - Add Internal Note',
    defaultMessage: 'Add Internal Note',
    id: '82Ggm4',
  },
  addTag: {
    description: 'Workflow action type label - Add Tag',
    defaultMessage: 'Add Tag',
    id: 'UVUA+H',
  },
  addTaxIdentifiers: {
    description: 'Workflow action type label - Add Tax Identifiers',
    defaultMessage: 'Add Tax Identifiers',
    id: '4PJblr',
  },
  adjustWeight: {
    description: 'Workflow action type label - Adjust Weight',
    defaultMessage: 'Adjust Weight',
    id: 'fHry/L',
  },
  assignToUser: {
    description: 'Workflow action type label - Assign to User',
    defaultMessage: 'Assign to User',
    id: '8V36bC',
  },
  billDutiesToSender: {
    description: 'Workflow action type label - Bill International Duties to Payor',
    defaultMessage: 'Bill International Duties to Payor',
    id: 'y8VPKe',
  },
  blockAmazonLogistics: {
    description: 'Workflow action type label - Block Amazon Logistics',
    defaultMessage: 'Block Amazon Logistics',
    id: 'ukWfLg',
  },
  chargeToMyAccount: {
    description: 'Workflow action type label - Charge Shipping to My Account',
    defaultMessage: 'Charge Shipping to My Account',
    id: 'X3slYl',
  },
  createAlert: {
    description: 'Workflow action type label - Create Alert',
    defaultMessage: 'Alert',
    id: 'Zc5g69',
  },
  dangerousGoods: {
    description: 'Workflow action type label - Mark as Dangerous Goods (Legacy)',
    defaultMessage: 'Mark as Dangerous Goods',
    id: 'x5TVvy',
  },
  declarationStatement: {
    description: 'Workflow action type label - Set Declaration Statement',
    defaultMessage: 'Declaration Statement',
    id: '5pfioX',
  },
  delegateFulfillmentService: {
    description: 'Workflow action type label - Delegate to Fulfillment Provider Service',
    defaultMessage: 'Delegate to Fulfillment Provider Service',
    id: 'yirXWo',
  },
  doNotImport: {
    description: 'Workflow action type label - Do Not Import Order',
    defaultMessage: 'Do Not Import Order',
    id: 'aOopfc',
  },
  doNotNotifyMarketplace: {
    description: 'Workflow action type label - Do Not Notify Marketplace',
    defaultMessage: 'Do Not Notify Marketplace',
    id: 'e0kg1q',
  },
  holdOrder: {
    description: 'Workflow action type label - Hold Order',
    defaultMessage: 'Hold Order',
    id: 'nWpgBN',
  },
  insurePackage: {
    description: 'Workflow action type label - Insure Package',
    defaultMessage: 'Insure Package',
    id: 'kNYwJ1',
  },
  holdUntil: {
    description: 'Workflow action type label - Hold Until',
    defaultMessage: 'Hold Until',
    id: 'TsI+t9',
  },
  markAlcohol: {
    description: 'Workflow action type label - Mark as Containing Alcohol',
    defaultMessage: 'Mark as Containing Alcohol',
    id: 'yWDQoW',
  },
  markDryIce: {
    description: 'Workflow action type label - Mark as Containing Dry Ice',
    defaultMessage: 'Mark as Containing Dry Ice',
    id: 'WQyJ1S',
  },
  markNonMachinable: {
    description: 'Workflow action type label - Mark as Non-Machinable',
    defaultMessage: 'Mark as Non-Machinable',
    id: 'a8pyqB',
  },
  noPostage: {
    description: 'Workflow action type label - Do Not Prepay Postage',
    defaultMessage: 'Do Not Prepay Postage',
    id: 'UA0k+2',
  },
  noteToBuyer: {
    description: 'Workflow action type label - Note to Buyer',
    defaultMessage: 'Note to Buyer',
    id: 'fTD1Zg',
  },
  requestConfirmation: {
    description: 'Workflow action type label - Delivery Confirmation',
    defaultMessage: 'Delivery Confirmation',
    id: 'zZkJBf',
  },
  saturdayDelivery: {
    description: 'Workflow action type label - Enable Saturday Delivery',
    defaultMessage: 'Enable Saturday Delivery',
    id: 'TsEMQr',
  },
  sendEmail: {
    description: 'Workflow action type label - Send an Email',
    defaultMessage: 'Recipient Email Addresses (comma-separated list)',
    id: 'ydwJym',
  },
  setCustomField1: {
    description: 'Workflow action type label - Set Custom Field 1',
    defaultMessage: 'Custom Field 1',
    id: 'UDZwUU',
  },
  setCustomField2: {
    description: 'Workflow action type label - Set Custom Field 2',
    defaultMessage: 'Custom Field 2',
    id: 'X13Drc',
  },
  setCustomField3: {
    description: 'Workflow action type label - Set Custom Field 3',
    defaultMessage: 'Custom Field 3',
    id: 'crewvx',
  },
  setCustomsContentType: {
    description: 'Workflow action type label - Customs Content Type',
    defaultMessage: 'Customs Content Type',
    id: 'dADiSm',
  },
  setDeliverByDate: {
    description: 'Workflow action type label - Set Deliver By Date',
    defaultMessage: 'Set Deliver By To',
    id: 'FvrGPc',
  },
  setDryIceWeight: {
    description: 'Workflow action type label - Set Dry Ice Weight',
    defaultMessage: 'Dry Ice Weight',
    id: 'PpgiOD',
  },
  setNonDelivery: {
    description: 'Workflow action type label - International Non-Delivery',
    defaultMessage: 'International Non-Delivery',
    id: 'sJgkg7',
  },
  setPackageDimensions: {
    description: 'Workflow action type label - Set Package Dimensions',
    defaultMessage: 'Dimensions',
    id: 'haf7iW',
  },
  setShipByDate: {
    description: 'Workflow action type label - Set Ship By Date',
    defaultMessage: 'Set Ship By To',
    id: 'xTouIN',
  },
  setShipDate: {
    description: 'Workflow action type label - Set Ship Date',
    defaultMessage: 'Set Ship Date',
    id: 'rYPBzp',
  },
  setShipFrom: {
    description: 'Workflow action type label - Ship From Location',
    defaultMessage: 'Ship From Location',
    id: 'eLqiY0',
  },
  setTotalWeight: {
    description: 'Workflow action type label - Set Total Weight',
    defaultMessage: 'Set Order Total Weight',
    id: '10tvff',
  },
  shipperRelease: {
    description: 'Workflow action type label - Enable Shipper Release',
    defaultMessage: 'Enable Shipper Release',
    id: 'QBP4vo',
  },
  showPostagePaid: {
    description: 'Workflow action type label - Show Postage Paid',
    defaultMessage: 'Show Postage Paid',
    id: 'lmmQI8',
  },
  stopProcessing: {
    description: 'Workflow action type label - Stop Processing Rules',
    defaultMessage: 'Stop Processing Rules',
    id: 'Wt9rJD',
  },
  useBlankBox: {
    description: 'Workflow action type label - Use Blank Box',
    defaultMessage: 'Use Blank Box',
    id: '4gDmTY',
  },
  useDeliveryNotificationTemplate: {
    description: 'Workflow action type label - Use Delivery Notification Template',
    defaultMessage: 'Use Delivery Notification Template',
    id: '1H5dYP',
  },
  usePackingSlip: {
    description: 'Workflow action type label - Use Packing Slip',
    defaultMessage: 'Use Packing Slip Template',
    id: 'f7oS1N',
  },
  useShipmentNotificationTemplate: {
    description: 'Workflow action type label - Use Shipment Notification Template',
    defaultMessage: 'Use Shipment Notification Template',
    id: 'FZWxip',
  },
});
